import { string } from "prop-types"
import styles from "./index.module.scss"

const Tag = props => {
  const { text } = props
  return (
    <div className={styles.TagWrapper}>
      <span className='Tag__text'>{text}</span>
    </div>
  )
}
Tag.propTypes = {
  text: string.isRequired
}
export default Tag